import React from 'react';
import classnames from 'classnames';
import {products} from '../../../setting';

export default function ProductRecommendations({isLandscape}) {
  return (
    <div className="skincaredetectionpreview-results__recommend-container">
      {products.map((prod, i) => (
        <div
          key={i}
          className={classnames({
            'skincaredetectionpreview-results__recommend-product': true,
            'skincaredetectionpreview-results__recommend-product--landscape': isLandscape,
          })}
        >
          <div
            className={classnames({
              'skincaredetectionpreview-results__recommend-product-img': true,
              'skincaredetectionpreview-results__recommend-product-img--landscape': isLandscape,
            })}
            style={{backgroundImage: `url(${prod.image})`}}
          />
          <div
            className={classnames({
              'skincaredetectionpreview-results__recommend-product-name': true,
              'skincaredetectionpreview-results__recommend-product-name--landscape': isLandscape,
            })}
          >
            {prod.name}
          </div>
        </div>
      ))}
    </div>
  );
}
